// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OperacaoCompromissos_TimelineInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /dashboards/operacao_compromissos/timeline
 *
 * Validates the bucket query parameter for timeline bucketing.
 */
import { registerContract } from './validate'

export interface OperacaoCompromissos_TimelineInput {
bucket?: string
}

registerContract('OperacaoCompromissos_TimelineInput', {
  bucket: { type: 'string',  required: false },
})
